import { gql } from '@apollo/client';

export default gql`
  query GetAsset($input: GetAssetInput) {
    getAsset(input: $input) {
      mId
      mRefId
      mAssetId
      mTitle
      mType
      mediaType
      mThumbnailUrl
      mContentUrl
      itemType
      mMetaData {
        key
        value
      }
    }
  }
`;
